export enum FileErrorKey {
  MULTIPLE = "MULTIPLE",
  DUPLICATE = "DUPLICATE",
}
